import {
  Tooltip,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import {
  ArrowDownward,
  ArrowUpward,
  FiberManualRecord,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    equals: {
      color: grey[400],
    },
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    downTrend: {
      color: theme.palette.statusRed.main,
    },
    fullHeight: {},
    upTrend: {
      color: theme.palette.statusGreen.main,
    },
    cellChanged: {
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    cell: {},
    cards: {
      height: "100%",
    },
    tableCell: {},
  })
);

export interface kpi_line {
  name: string;
  currentValue: number;
  predictedValue: number;
}

export function prettyPrintKPI(colName: string, value: number) {
  let ret = "";
  if (value < 0) ret = "-";

  if (
    colName.toLowerCase().indexOf("rev") >= 0 ||
    colName.toLowerCase().indexOf("grlc") >= 0
  ) {
    ret += "$";
  }

  ret += Math.abs(value).toFixed(2);

  if (colName.toLowerCase().indexOf("rate") >= 0) {
    ret += "%";
  }

  if (colName.toLowerCase().indexOf("days") >= 0) {
    ret = `${value }`;
    ret += " Days";
  }

  return ret;
}

export default function CardKPI(props: { kpis: any }) {
  const classes = useStyles();
  const kpis = props.kpis;
  const obj: any = {};

  const kpiTypes = [
    {
      name: "Avg. Visit Period",
      field: "avg",
    },
    {
      name: "Days Until Stockout",
      field: "days_cover",
    },
    {
      name: "Vends/Day",
      field: "eaches",
    },
    {
      name: "Eff. Fill Rate",
      field: "efr",
    },
    {
      name: "GRLC/Day",
      field: "grlc",
    },
    {
      name: "Rev/Day",
      field: "rev",
    },
  ];

  for (let i of kpiTypes) {
    obj[i.name] = {};

    if (i.field === "avg") {
      obj[i.name].predict = kpis[1][i.field];
      obj[i.name].current = kpis[1][i.field];
    } else {
      try {
        obj[i.name].predict = kpis[0][i.field];
        obj[i.name].current = kpis[1][i.field];
      } catch (e) {
        continue;
      }
    }
  }

  return (
    <Card className={classes.cards}>
      <CardContent className={classes.fullHeight}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {Object.keys(obj).map((v: any) => (
                  <TableCell align="center">{v}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                {Object.entries(obj).map((e: any) => {
                  let v = e[1];

                  let calc0 = prettyPrintKPI(
                    e[0],
                    Math.round(100 * v.current) / 100
                  );
                  let calc1 = prettyPrintKPI(
                    e[0],
                    Math.round(100 * v.predict) / 100
                  );

                  if (!!v.tooltip) {
                    return (
                      <Tooltip title={v.tooltip}>
                        <TableCell align="center" className={classes.tableCell}>
                          {calc1}
                        </TableCell>
                      </Tooltip>
                    );
                  }

                  if (calc0.localeCompare(calc1) === 0) {
                    return (
                      <Tooltip title="Unchanged">
                        <TableCell align="center" className={classes.tableCell}>
                          {calc1}
                        </TableCell>
                      </Tooltip>
                    );
                  }

                  return (
                    <Tooltip title="Current vs. Predicted">
                      <TableCell align="center" className={classes.tableCell}>
                        {calc0}
                        {v.current > v.predict ? (
                          <ArrowDownward
                            className={classes.downTrend}
                            fontSize="small"
                          />
                        ) : v.current < v.predict ? (
                          <ArrowUpward
                            className={classes.upTrend}
                            fontSize="small"
                          />
                        ) : (
                          <FiberManualRecord
                            className={classes.equals}
                            fontSize="small"
                          />
                        )}
                        {calc1}
                      </TableCell>
                    </Tooltip>
                  );
                })}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
